export const jobStates: KeyValue[] = [
  { key: 'Pending', value: 0 },
  { key: 'Running', value: 1 },
  { key: 'Completed', value: 2 },
  { key: 'Failed', value: 3 }
];

export class KeyValue {
  key: string;
  value: number;
}
